module.exports = __webpack_public_path__ + "img/img06.462638f7.jpg";